import types from '../../../mutation-types';
import MessageApi from 'dashboard/api/inbox/message';

export const restoreHistory = async (context, data, messageId, isCurrent) => {
  const conversationId = data.id;
  const latestId = Math.max(
    data.historyLatestObservedId || 0,
    ...data.messages
      .filter(message => typeof message.id === 'number')
      .map(message => message.id)
  );
  const anchorId = Number(messageId);
  const [older, newer] = await Promise.all([
    MessageApi.getPreviousMessages({ conversationId, before: anchorId }),
    MessageApi.getPreviousMessages({
      conversationId,
      after: anchorId,
      before: latestId + 1,
    }),
  ]);
  if (!isCurrent()) return false;
  context.commit(`conversationMetadata/${types.SET_CONVERSATION_METADATA}`, {
    id: conversationId,
    data: newer.data.meta,
  });
  context.commit(types.SET_CONVERSATION_HISTORY_WINDOW, {
    id: conversationId,
    data: [...older.data.payload, ...newer.data.payload],
    latestId,
    hasMoreAfter: !newer.data.payload.some(message => message.id === latestId),
    allMessagesLoaded: older.data.payload.length < 20,
  });
  context.dispatch('autoTranslateMessages', conversationId);
  return true;
};
